import { RouteRecordRaw } from "vue-router";

export const systemRoutes: Array<RouteRecordRaw> = [

    {
        path: '/',
        name: 'system-layout',
        component: () => import('@/layouts/SystemLayout.vue'),
        meta: {
            requiresAuth: true,
            tenant_type: ['system'],
        },
        children: [
            {
                path: '',
                name: 'default-system',
                redirect: '/dashboard',
            },
            {
                path: 'dashboard',
                name: 'admin-dashboard',
                component: () => import('@/pages/admin/AdminPage.vue'),
            },
            {
                path: 'companies',
                name: 'admin-companies',
                component: () => import('@/pages/admin/tenant/TenantPage.vue'),
            },
            {
                path: 'templates-editor',
                component: () => import('@/pages/admin/templates-editor/TemplatesEditor.vue')
            },
            {
                path: 'features',
                component: () => import('@/pages/admin/features/FeaturesPage.vue')
            },
            {
                path: 'admin-settings',
                component: () => import('@/pages/admin/admin-settings/SystemSettings.vue'),
            },
            {
                path: 'audit-logs',
                name: 'audit-logs-system',
                component: () => import('@/pages/audit-logs/AuditLogsPage.vue'),
            },
        ],
    },
];